<template>
  <div
    class="show-result-modal"
    :class="{
      'invisible': isShowingImage
    }"
  >
    <div class="modal-content">
      <h4 class="header">
        {{ $t('Results are hidden') }}
      </h4>
      <p class="submission">
        {{ submissionText }}
      </p>
      <aha-button class="show-result-button" @click="showResult">
        {{ $t('Show results') }}
        <span class="hot-key">H</span>
      </aha-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import EventBus from '@/eventBus'

export default {
  name: 'ShowResultModal',
  props: {
    numberOfSubmissions: {
      type: Number,
      default: null,
    },
    isShowingImage: {
      type: Boolean,
      default: true,
    },
    slideId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    submissionText() {
      if (!this.numberOfSubmissions) return null

      return `${this.numberOfSubmissions} ${this.numberOfSubmissions > 1
        ? this.$t('submissions') : this.$t('submission')} ${this.$t('received')}.`
    },
  },
  methods: {
    showResult() {
      this.$emit('toggleResult', true)
      EventBus.$emit('display-hide-result-pill-tooltip')
      const listShowedResult = JSON.parse(localStorage.getItem('list_showed_result_id') || '[]')
      // check is array

      if (this.slideActive) {
        if (!listShowedResult.includes(this.slideActive.id)) {
          listShowedResult.push(this.slideActive.id)
        }

        localStorage.setItem('list_showed_result_id', JSON.stringify(listShowedResult))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.show-result-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 28;
  background: #fff;
  color: #333;
  border-radius: 8px;
  &.invisible {
    display: none;
  }
  .modal-content {
    padding: 32px 48px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0px 8px 14px rgba(82, 95, 127, 0.13) !important;
  }

  .header {
    font-weight: bold;
    text-align: center;
    font-size: 1.3em;
  }
  .submission {
    color: #828282;
    margin-bottom: 16px !important;
  }

  & .show-result-button {
    display: flex;
    gap: 1rem;

    & .hot-key {
      @apply text-white-100 text-sm;
      padding: 0.25rem 0.5rem;
      background-color: #2271CC;
      border-radius: 4px;
    }
  }
}

</style>
